module.exports = __webpack_public_path__ + "img/centiva_light.bdea0242.svg";